export const calculateDiscount = (base, final) => {
    return Math.ceil(100 - (Number(final) / Number(base)) * 100);
};
